import { render, staticRenderFns } from "./AppLabelFileupload.vue?vue&type=template&id=4eb81dd5&scoped=true"
import script from "./AppLabelFileupload.vue?vue&type=script&lang=js"
export * from "./AppLabelFileupload.vue?vue&type=script&lang=js"
import style0 from "./AppLabelFileupload.vue?vue&type=style&index=0&id=4eb81dd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb81dd5",
  null
  
)

export default component.exports